import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const SnapchatDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 320" transform="translate(-356.229 -157.655)">
      <rect
        data-name="\u9577\u65B9\u5F62 764"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(356.229 157.655)"
      />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 319">
        <path
          data-name="\u30D1\u30B9 1025"
          d="M494.5 347.111V179.3a14.309 14.309 0 00-14.309-14.308h-14.122v1.918a7.586 7.586 0 01-7.586 7.586h-59.117a7.586 7.586 0 01-7.586-7.586v-1.918h-14.962A14.308 14.308 0 00362.51 179.3v167.811z"
          fill="#212121"
        />
      </g>
      <path data-name="\u9577\u65B9\u5F62 765" fill="#fff" d="M390.815 192.446h34.371v3.938h-34.371z" />
      <path data-name="\u9577\u65B9\u5F62 766" fill="#fff" d="M390.815 184.516h55.231v4.208h-55.231z" />
      <path
        data-name="\u30D1\u30B9 1026"
        d="M362.51 347.557v89.337a14.308 14.308 0 0014.308 14.306h103.374a14.309 14.309 0 0014.308-14.306v-89.337z"
        fill="#212121"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 767"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(409.935 443.679)"
        fill="#fff"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 768"
        width={132.044}
        height={132.006}
        rx={6.736}
        transform="rotate(90 145.272 349.12)"
        fill="#fffd49"
      />
      <path data-name="\u9577\u65B9\u5F62 769" fill="#212121" d="M416.819 425.501h23.142v3.938h-23.142z" />
      <circle
        data-name="\u6955\u5186\u5F62 461"
        cx={8.112}
        cy={8.112}
        r={8.112}
        transform="translate(369.36 182.074)"
        fill="#424242"
      />
    </g>
  </Root>
);

const Root = styled('svg')();

export default SnapchatDevice11;
